import { SvgIcon } from "@mui/material";
import React from "react";

function AnnoucementIcon(props) {
  return (
    <SvgIcon viewBox="0 0 43 39" fill="#FF9B04" {...props}>
      <ellipse cx="21.1596" cy="19.5" rx="21.1596" ry="19.5" fill="#FF9B04" />
      <path
        d="M14 22L17 30H21L18 22M28 21C28.394 21 28.7841 20.9224 29.1481 20.7716C29.512 20.6209 29.8427 20.3999 30.1213 20.1213C30.3999 19.8427 30.6209 19.512 30.7716 19.1481C30.9224 18.7841 31 18.394 31 18C31 17.606 30.9224 17.2159 30.7716 16.8519C30.6209 16.488 30.3999 16.1573 30.1213 15.8787C29.8427 15.6001 29.512 15.3791 29.1481 15.2284C28.7841 15.0776 28.394 15 28 15M20 26C21 26 23 25 23 23M20 22C23 22 28 26 28 26V10C28 10 23 14 20 14V22ZM11 18C11 14.889 12.791 14 15 14H20V22H15C12.791 22 11 21.111 11 18Z"
        stroke="white"
        fill="#FF9B04"
        strokeWidth="2"
      />
    </SvgIcon>
  );
}

export default AnnoucementIcon;
